import React from 'react';

const Attention = (props) => (
  <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9.876 7.264L11.1 7.132L10.896 13.816H10.116L9.876 7.264ZM9.768 15.292C9.768 15.1 9.836 14.936 9.972 14.8C10.108 14.656 10.276 14.584 10.476 14.584C10.684 14.584 10.86 14.656 11.004 14.8C11.148 14.936 11.22 15.1 11.22 15.292C11.22 15.492 11.148 15.66 11.004 15.796C10.86 15.932 10.684 16 10.476 16C10.276 16 10.108 15.932 9.972 15.796C9.836 15.66 9.768 15.492 9.768 15.292Z" fill="#FF0000"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M3.38254 20C1.86134 20 0.897013 18.3691 1.63011 17.0362L9.20577 3.26223C9.97423 1.86504 11.9887 1.88496 12.7294 3.29708L19.9539 17.071C20.6524 18.4027 19.6866 20 18.1828 20H3.38254Z" stroke="#FF0000"/>
  </svg>
);

export default React.memo(Attention);
